/*
PM 2021-07-29
KONCEPCJA KOMPONENTU
================

Komponent kontener dla komponentu mapy ./Map
Opis propsow podawanych do dziecka mozna zobaczyc w interfejsie MapProps w komponencie ./Map

================

Funkcja getIcon zwraca pineskę odpowiedniego koloru na podstawie koloru (webSerwis /mapy/dajMapaObiekty lub /mapy/dajMapaObiekty1, zależnie od projektu)
Warianty takie jak w redmine brane z ./mapData

================
importowane komponenty:
import Map from './Map';

*/

import * as React from 'react';

import {
    getIcon, tiles
} from './mapData';

import Map from './Map';

import { connect } from 'react-redux';

import { AppState, store, Actions } from '../../appredux';
import CONFIG from '../../cfg/config';
import { sendErrorLog } from '../common/helpers';
import { Info } from '../../api';

import {distance, Dist, HaversineInM, gpsToNumber} from './Distance'

//GoogleAnalytics
import ReactGA from 'react-ga';


export class MapData {
    
    obiektGPS: string = ''; 
    obiektLat: number = 0; 
    obiektLng: number = 0;

    klientAdres: string = ''; 
    klientGPS: string = ''; 
    klientLat: number = 0;
    klientLng: number = 0; 

    dokNr: string = ''; 

    constructor(data?: any) {
      if (data) {
        this.obiektGPS = data.obiektGPS || '';
        this.obiektLat = data.obiektLat || 0;
        this.obiektLng = data.obiektLng || 0;
        this.klientAdres = data.klientAdres || '';
        this.klientGPS = data.klientGPS || '';
        this.klientLat = data.klientLat || 0;
        this.klientLng = data.klientLng || 0;
        this.dokNr = data.dokNr || '';
      }
    }
  }

// export interface MapInterface {
//     obiektGPS: string, 
//     klientAdres: string, 
//     klientGPS: string,
//     klientLat: number, 
//     klientLng: number, 
//     dokNr: string, 


// }

//PM 2021-11-30
//wstrzykniecie tylko uzywanych pol z magazynu danych
interface MapContainerProps {
    contact: Info,
    map: MapData
}

//PM 2021-10-19
//tileErrors: number[],
//tileName: string,
interface MapContainerState {
    tooltip: string, //opis przy pinesce
    tileErrors: string[],
    tileName: string,
    latClient: number,
    lngClient: number,
    distance: number,
    address: string,

    update: boolean,

}

//komponent zarządzający stanem mapy
//przekazuje stan i funkcje jako propsy do komponentu Map.tsx
class MapContainer extends React.Component<MapContainerProps, MapContainerState>  {

    //PM 2021-10-19
    //tileErrors: [],
    //tileId: 1,
    constructor(props: MapContainerProps) {
        super(props, {});

        let text = CONFIG.hotelID.split(" ").map((current: string) => current.charAt(0).toUpperCase() + current.slice(1).toLowerCase()).join(" ")
        text = text.split("-").map((current: string) => current.charAt(0).toUpperCase() + current.slice(1)).join("-")

        this.state = {
            tooltip: text,
            tileErrors: [],
            tileName: tiles[1].name,

            latClient: 0,
            lngClient: 0,
            distance: 0,
            address: "",
            update: false
        }
        store.dispatch(Actions.pageState.addFcmLogMessage("okno glowne mapa", 0))
        sendErrorLog("1", "1", 'okno glowne mapa')

        ReactGA.event({
          category: 'Nawigacja',
          action: 'Mapa'
        });

        // setTimeout(() => { //50.0443566N 21.9925000E|Rzeszow, Podwislocze 22|123
        //    store.dispatch(Actions.pageState.setMap({obiektGPS: "50.0443566N 21.9925000E", klientAdres: "Rzeszow, Podwislocze 22", dokNr: "123", klientGPS: "", klientLat: 0, klientLng: 0}));
        // }, 3000);
    }

    componentDidUpdate(prevProps: MapContainerProps) {
        //console.log(this.props.map)

        //wyszukanie na mapie
        if(this.props.map.klientLat !== prevProps.map.klientLat){ 
            let gpsReturn = gpsToNumber(this.props.map.obiektGPS);
            let latNumber = gpsReturn.lat;
            let lngNumber = gpsReturn.lng;
            let distance = Math.round( HaversineInM(latNumber, lngNumber, this.props.map.klientLat, this.props.map.klientLng) )  
            //console.log(latNumber, lngNumber, this.props.map.klientLat, this.props.map.klientLng, distance) 
            this.setState({latClient: this.props.map.klientLat, lngClient: this.props.map.klientLng, distance: distance, address: this.props.map.klientAdres})
       
        //powiadomienie
        } else if(this.props.map.klientAdres !== prevProps.map.klientAdres){ 
            this.findAddress()
        }
    }

    findAddress = async () => {
        let dist = await distance(this.props.map.klientAdres, this.props.map.obiektGPS) 
        this.setState({latClient: dist.lat, lngClient: dist.lng, distance: dist.distance, address: this.props.map.klientAdres})
    }

    //PM 2021-10-19
    addTileError = async (aName: string) => {
        const tileErrors = this.state.tileErrors

        tileErrors.push(aName)
        this.setState({ ...this.state, tileErrors: tileErrors })
        store.dispatch(Actions.pageState.addFcmLogMessage("blad mapy", 2))
        await sendErrorLog("0", "-1", 'błąd mapy')
    }

    //PM 2021-10-19
    setTileName = async (aName: string) => {
        this.setState({ ...this.state, tileName: aName })
    }

    update = () => {
        let d = new MapData({ 
            obiektGPS: this.props.map.obiektGPS, 
            obiektLat: this.props.map.obiektLat, 
            obiektLng: this.props.map.obiektLng,
            klientAdres: '',
            klientGPS: '',
            klientLat: 0,
            klientLng:  0,
            dokNr: '',
         })
        store.dispatch(Actions.pageState.setMap(d, true));

        this.setState({
            latClient: 0,
            lngClient: 0,
            distance: 0,
            address: "",
            update: true
        })
        //console.log("qwe")
        //this.forceUpdate()
    }

    render = () => {

        //console.log(this.props.map)
        //console.log(this.state)

        let latNumber = this.props.map.obiektLat;
        let lngNumber = this.props.map.obiektLng;


        const promien = 0.045; 

        //vscTest
        //console.log(latNumber, lngNumber)
        if (this.state.update) {
            this.setState({ update: false })

            let interval = setInterval(() => {
                let input = document.getElementsByClassName("glass")
                if (input.length > 0) {
                    let inputValue = townName(this.props.contact.kontaktAdres)
                    input[0].setAttribute("value", inputValue + ", ")
                }
            }, 100);

            setTimeout(() => {
                clearInterval(interval)
            }, 1000);

        }

        return (
            <>
            {!this.state.update ?
            <Map
                getIcon={getIcon} //pobieranie koloru pineski
                latObiekt={latNumber}   //szer. geogr.
                lngObiekt={lngNumber}   //dl. geogr.
                latClient={this.state.latClient}   //szer. geogr.
                lngClient={this.state.lngClient}   //dl. geogr.
                distance={this.state.distance}
                address={this.state.address}
                bounds={[         //początkowe granice mapy
                    [latNumber + promien, lngNumber - promien],
                    [latNumber - promien, lngNumber + promien],
                ]}
                tooltip={this.state.tooltip} //opis przy pinesce
                addTileError={this.addTileError}
                setTileName={this.setTileName}
                tileErrors={this.state.tileErrors}
                tileName={this.state.tileName}
                update={this.update}
            />
            : null }
            </>
        );
    }

}

const mapStateToProps = (state: AppState) => ({
    contact: state.pageState.contact,
    map: state.pageState.map
});

export default connect(mapStateToProps)(MapContainer);

export function townName(address: string) {
    // let places = [
    //   'Mielec, Biernackiego 12',
    //   'Biernackiego 12, Mielec',
    //   '35-211 Rzeszów, Kamińskiego 8/4',
    //   'Zamkowa 5, 34-436 Czorsztyn',
    //   'Weremień 36, 38-600 Lesko',
    //   '38-607 Cisna, 48A',
    //   'Cisna, 48A, 38-607'

    // ]

    


    //let p = places.map((s: string) => {

      //this.props.page.contact.kontaktAdres
      let addressSplit = address.split(" ")
      //let addressSplit = s.split(" ")
      if (addressSplit.length > 0) {
        let i = addressSplit.findIndex((s: string) => s.length === 6 && s.includes('-'))
        if (i === -1) {//nie ma kodu pocztowego

          
          switch (CONFIG.hotelID) {
            case "mielec-POLSKI":
              return "Mielec"
            case "czorsztyn-UMINA":
              return "Czorsztyn"
            case "lesko-SKI":
              return "Lesko"
            case "cisna-U-KARNASOW":
              return "Cisna"
            case "zary-HAYDUK":
              return "Żary"
            case "TOSHIBA":
            case "hotel-TEST":
              return "Rzeszów"
              
            default:
              return ""
          }

        }
        //console.log(i)
        if (addressSplit[i + 1]) { //znaleziono kod pocztowy
            let town = addressSplit[i + 1]
            if(town.charAt(town.length - 1) === ",") return town.substr(0, town.length -1) 
            return town 
        } 
        //nie ma wyrazu po kodzie pocztowym
        return ''  
      }
      //błędny adres
      return ''


    //})

    //console.log(p)

  }